<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'text', label: '점검자', value: '점검자' },
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" :title="$t('예방 점검표')" contentBefore="•" v-model="form.inspectList" class="mt-28px" />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검자: { required },
        점검일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},

        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        inspectList: [
          {
            content: "<span class='font-normal'>위험물을 작업장 외 별도 장소에 보관하고, 작업에 필요한 양만 비치하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제16조)</span>",
            isChecked: "",
            title: "위험물 취급",
          },
          {
            content: "<span class='font-normal'>폭발·화재 및 누출을 방지하기 위한 적절한 방호조치를 하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제225~238조)</span>",
            isChecked: "",
            title: "위험물 취급",
          },
          {
            content: "<span class='font-normal'>통로가 안전하게 사용될 수 있도록 유지하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제22조)</span>",
            isChecked: "",
            title: "작업장 안전상태",
          },
          {
            content: "<span class='font-normal'>인화성가스 등이 체류하지 않도록 환기장치가 설치되었는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제232조)</span>",
            isChecked: "",
            title: "작업장 안전상태",
          },
          {
            content: "<span class='font-normal'>특정장소에서 용접·용단 작업을 하도록 하는 경우 화재감시자를 배치하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제241조의2)</span>",
            isChecked: "",
            title: "작업장 안전상태",
          },
          {
            content: "<span class='font-normal'>화재·폭발 우려가 있는 장소에서 화기 사용을 금지하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제242조)</span>",
            isChecked: "",
            title: "작업장 안전상태",
          },
          {
            content: "<span class='font-normal'>작업장에 비상구가 출입문 외에 1개 이상 설치되고 사용할 수 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제17조, 제18조)</span>",
            isChecked: "",
            title: "비상조치",
          },
          {
            content: "<span class='font-normal'>화재 등 비상상황을 신속하게 알릴 수 있는 경보용·설비 기구가 설치되었는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제19조)</span>",
            isChecked: "",
            title: "비상조치",
          },
          {
            content: "<span class='font-normal'>적합한 소화설비를 비치·사용하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제243조)</span>",
            isChecked: "",
            title: "비상조치",
          },
          {
            content: "<span class='font-normal'>MSDS 대상 물질을 취급하는 근로자에게 교육을 실시하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(산업안전보건법 제114조)</span>",
            isChecked: "",
            title: "물질안전보건자료 (MSDS)",
          },
          {
            content: "<span class='font-normal'>MSDS 대상 물질을 취급하는 작업장 내 취급 근로자가 쉽게 볼 수 있도록 게시하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(산업안전보건법 제114조)</span>",
            isChecked: "",
            title: "물질안전보건자료 (MSDS)",
          },
          {
            content: "<span class='font-normal'>MSDS 대상 물질을 담은 용기 및 포장에 경고표시를 적정히 하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(산업안전보건법 제115조)</span>",
            isChecked: "",
            title: "물질안전보건자료 (MSDS)",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검자"].required) return "점검자를 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
